export default "__VITE_ASSET__wEBg_3T9__"